export const CLEANING_STEPS = [
  "Sweeping / remove previous cargo",
  "Washing down with high pressure seawater",
  "Rinsing with fresh water",
  "Previous cargo residues removed from hold pipes, brackets and guards",
  "Descaling of tank top",
  "Cement residues removed from catchments, ladders and manholes",
  "Previous cargo residues removed from under deck and shedder plates",
  "Drying up including bilges",
  "Limewash removed from hidden areas",
  "Loose paint removed from hatch coaming and ladders",
  "Loose paint and rust scale removed from hoppers and bulkheads",
  "Touch-up paint",
  "Final inspection",
] as const;
